import { render, staticRenderFns } from "./HeroBlock.vue?vue&type=template&id=794c677d&scoped=true"
import script from "./HeroBlock.vue?vue&type=script&lang=js"
export * from "./HeroBlock.vue?vue&type=script&lang=js"
import style0 from "./HeroBlock.vue?vue&type=style&index=0&id=794c677d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "794c677d",
  null
  
)

export default component.exports